import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './apollo/client';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import esriConfig from "@arcgis/core/config";
// CSS de ArcGIS desde el paquete npm: siempre en la misma versión que el JS
// (antes venía del CDN pinneado a 4.28 y podía desincronizarse)
import '@arcgis/core/assets/esri/themes/light/main.css';
import './index.css';

// Configurar ArcGIS para usar OpenStreetMap
esriConfig.request.useIdentity = false;
esriConfig.request.timeout = 60000;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  </React.StrictMode>
);
